module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_10.a53e3d34.png";